app.headerController = app.headerController || {};
app.headerController.defaultAction = {
   
    /**
     * Initialisation de la fonction
     * @returns {undefined}
     */
    init : function () {
        this.showMainNav();
        this.scrollHeader();
    },

    scrollHeader : function () {
        var scrollOffset = function() { return $(document).scrollTop(); };

        $(document).on('scroll', function() {
            if (scrollOffset() > 0 ) {
                $('body').addClass('scroll');
            }
            else {
                $('body').removeClass('scroll');
            }
        });
    },

    showMainNav : function () {
        var $toggleNav = $('.toggleNav');

        if($toggleNav.length > 0) {

            // Toggle nav + overlay
            $('.siteHeader').append('<div id="header-overlay" class="overlay overlay-header"></div>');
            $toggleNav.on(app.clickEvent, function(){
                $toggleNav.toggleClass('is-active');
                $('body').toggleClass('no-scroll');
                $('html').toggleClass('active-overlay-header');
                if ($toggleNav.hasClass('is-active')) {
                    $('body').addClass('active-menu');
                }
                else {
                    $('body').removeClass('active-menu');
                }
            });
            $('#header-overlay').on(app.clickEvent, function(){
                $toggleNav.removeClass('is-active');
                $('body').removeClass('no-scroll');
                $('html').removeClass('active-overlay-header');
                $('body').removeClass('active-menu');
            });



            // Sub menus
            var $parents = $('.mainNavMenu > .menu-item-has-children'),
                isMobile = false;

            // Fonctionnement js pour écrans < 768
            var mobileSubmenus = function() {
                $parents.each(function () {
                    var $menu = $(this).children('ul'),
                        $menuParentItem = $(this),
                        $menuParentLink = $(this).children('.menu-item-text');

                    $menu.hide();

                    $menuParentLink.on(app.clickEvent, function (e) {
                        e.preventDefault();
                        $menuParentItem.toggleClass('is-active');
                        $menu.animate({
                            height: "toggle"
                        }, 300, function () {
                            // Animation complete.
                        });

                        // On expand sub menu : close other sub menus
                        if ($menuParentItem.hasClass('is-active')) {
                            var $sublingParents = $(this).parents('.menu-item-has-children').siblings(),
                                $sublingMenus = $sublingParents.children('.sub-menu');
                            $sublingParents.removeClass('is-active');
                            $sublingMenus.animate({
                                height: "hide"
                            }, 300, function () {
                                // Animation complete.
                            });
                        }

                        // On collapse sub menu : close sub-sub menus
                        // if (! $menuParentItem.hasClass('is-active') && $menu.find('.menu-item-has-children').length > 0) {
                        //     $menu.find('ul').animate({
                        //         height : "hide"
                        //     }, 300, function() {
                        //         // Animation complete.
                        //     });
                        // }
                    });
                });
            };

            if ($(window).innerWidth() < 768) {
                mobileSubmenus();
                isMobile = true;
            }

            $(window).on('resize', function() {
                if ($(window).innerWidth() < 768) {
                    if (!isMobile) {
                        mobileSubmenus();
                        isMobile = true;
                    }
                }
                else if (isMobile) {
                    $parents.children('ul').css('display', '');
                    $parents.children('.menu-item-text').off();
                    isMobile = false;
                }
            });

            // Quick links
            $('.toggleQuickLinks').on(app.clickEvent, function(){
                $('.quickLinks').toggleClass('is-active');
            });

        }
    },

};

$(document).ready(function(){
    app.headerController.defaultAction.init();
});